import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class DownloadService {

    constructor(private http:HttpClient) {}

    getdocument(): Observable<Blob>{
      return this.http.get(`${environment.apiUrl}/upload.xlsx}`, { responseType: 'blob'});
    }


  file(duty: any, folder: any) {

      return this.http.post(`${environment.apiUrl}/keywords/upload?phaseid=${folder}`,duty);
  }

//  bulkupload(duty:any,level:number){
//    return this.http.post(`${environment.apiUrl}/test?id=${level}`, duty);
  
//}
 bulkupload(duty:any,level:number){
   return this.http.post(`${environment.apiUrl}/keywords/bulkupload?levelid=${level}`, duty);

 }
}


